import type { InternalAxiosRequestConfig } from 'axios'
import { firebaseAuth } from '#/firebase'

// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const authRequestInterceptor = async (config: InternalAxiosRequestConfig<any>) => {
	const token = await firebaseAuth.currentUser?.getIdToken()

	if (token) {
		config.headers.Authorization = `Bearer ${token}`
	}

	return config
}
